import React from "react";


const AddNewButton = (props) => {
    return (
        <button onClick={props.submitbtn} type="button" class="focus:outline-none text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:ring-green-300 font-medium rounded-sm text-sm px-5 py-2.5 dark:bg-green-600 dark:hover:bg-green-700 dark:focus:ring-green-800">{props.innerTxt}</button>
    )
}

export default AddNewButton